<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

const showFooter = ref(false)
const router = useRouter()

onMounted(() => {
  // Wait for router to be ready and route component to render
  router.isReady().then(() => {
    showFooter.value = true

    // Load the Hatfield Media footer script
    const script = document.createElement('script')
    script.src = 'https://assets.hatfieldmedia.com/en/hatfield-media-footer.js'
    script.async = true
    document.body.appendChild(script)
  })
})
</script>

<template>
  <footer v-if="showFooter" class="site-footer">
    <div class="footer-credit-wrapper">
      <div class="footer-credit-link">
        <a id="footer-hatfield-logo" class="footer-credit" href="https://hatfieldmedia.com" target="_blank" rel="noopener noreferrer"></a>
      </div>
      <div class="footer-info-wrapper">
        <div class="footer-info">
          <a id="site-info" href="/hatfield-media-credit"></a>
          <a id="copyright-info" href="/hatfield-media-copyright"></a>
          <a id="privacy-policy" href="/hatfield-media-privacy"></a>
          <a id="accessibility-statement" href="/accessibility"></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer-credit-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  background-color: #000;
  padding: 0.5rem 0.5rem;
}

.footer-credit-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-credit {
  width: 25px;
  height: 25px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
}

.footer-info-wrapper {
  display: flex;
  color: var(--color-white, #ffffff);
  align-items: center;
}

.footer-info {
  color: var(--color-white, #ffffff);
  font-size: 0.75rem;
  transition: 0.3s;
}

.footer-info a,
.footer-info p {
  color: var(--color-white, #ffffff);
  font-size: inherit;
  text-decoration: none;
}

.footer-info a:not(:last-child)::after,
.footer-info p:not(:last-child)::after {
  content: '|';
  margin: 0 0.5rem;
  color: var(--color-white, #ffffff);
}

.footer-info a:hover,
.footer-info a:focus,
.footer-info p:hover,
.footer-info p:focus {
  color: var(--color-secondary);
}

.footer-info p {
  margin: 0;
  display: inline;
  cursor: pointer;
}

@media (min-width: 767px) {
  .footer-info {
    font-size: 1rem;
    align-items: center;
  }
}
</style>
